
export default{

    data() {
        return {
            locale: 'mm',
            localeChangeCallback: null
        };
    },

    watch: {
        "$i18n.locale" : {
            handler(locale) {
                this.locale = locale;
            }
        }
    },

    mounted() {
        
        // EventBus.$on('localeChange', locale => {
        //     console.log('event trigger');
        //     this.locale = locale;
        //     if(this.localeChangeCallback){
        //         this.localeChangeCallback(locale);
        //     }
        // });
    }
}